// @ngInject
export default function MainRouterConfig($urlRouterProvider) {
  $urlRouterProvider.otherwise('/');
}



// WEBPACK FOOTER //
// ./src/main-routes.js